var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('Tags',{attrs:{"tags":_vm.tags,"scrollTo":_vm.scrollTo}}),_c('section',{staticClass:"menu-items"},_vm._l((_vm.blocks),function(b){return _c('Items',{key:b.tag,class:b.id,attrs:{"items":b.items}})}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }